import { calibrationDeviceRailStationVariants } from '@/features/calibration/config/calibrationDeviceRail';
import type { CalibrationDeviceTreeRow } from '@/features/calibration/types/calibrationDeviceTree';
import { Building2, ChevronDown, ChevronRight } from 'lucide-react';
import type { CSSProperties, Ref } from 'react';

export function CalibrationDeviceRailStationRow({
  row,
  onToggleStation,
  measureRef,
  virtualIndex,
  style,
}: {
  row: Extract<CalibrationDeviceTreeRow, { kind: 'station' }>;
  onToggleStation: (stationId: string) => void;
  measureRef: Ref<HTMLLIElement>;
  virtualIndex: number;
  style: CSSProperties;
}) {
  return (
    <li ref={measureRef} data-index={virtualIndex} style={style}>
      <button
        type="button"
        className={calibrationDeviceRailStationVariants({ expanded: row.expanded })}
        onClick={() => onToggleStation(row.station.id)}
      >
        {row.expanded ? (
          <ChevronDown className="size-3.5" />
        ) : (
          <ChevronRight className="size-3.5" />
        )}
        <Building2 className="size-3.5 text-muted-foreground" />
        <span className="min-w-0 flex-1 truncate">{row.station.name}</span>
      </button>
    </li>
  );
}
